// extracted by mini-css-extract-plugin
module.exports = {"contentItem":"BaseEditor_contentItem__2648i"};